// extracted by mini-css-extract-plugin
module.exports = {"feature_wrapper":"Feature_feature_wrapper___n_Ck","feature_title":"Feature_feature_title__UAM9M","feature_desc":"Feature_feature_desc__ejHwm"};